module.exports = __webpack_public_path__ + "img/google14.2f439af3.jpg";